import { Navigate, Outlet, useLocation } from "react-router";
import { useI18n } from "@wato/i18n/react";
import { AuthLayout, PageError, PageLoading } from "../components/common";
import { useAuth } from "./AuthProvider";

export const SETUP_ROUTE = "/security/two-factor/setup";

function Unreachable() {
  const { t } = useI18n();
  const { refresh } = useAuth();
  return (
    <AuthLayout title={t("dashboard.title")}>
      <PageError message={t("dashboard.auth.networkError")} onRetry={() => void refresh()} />
    </AuthLayout>
  );
}

/**
 * Routes that need a full session. Anonymous → `/login?next=…`; a restricted mandatory-2FA
 * session → the setup page (the API refuses workspace data anyway, ADR-0013).
 */
export function RequireAuth() {
  const { state } = useAuth();
  const location = useLocation();
  if (state.status === "loading") return <PageLoading />;
  if (state.status === "unreachable") return <Unreachable />;
  if (state.status === "anonymous") {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  if (state.status === "setup") return <Navigate to={SETUP_ROUTE} replace />;
  return <Outlet />;
}

/** Sign-in pages: a signed-in user goes straight to the app. */
export function GuestOnly() {
  const { state } = useAuth();
  if (state.status === "loading") return <PageLoading />;
  if (state.status === "ready") return <Navigate to="/" replace />;
  if (state.status === "setup") return <Navigate to={SETUP_ROUTE} replace />;
  return <Outlet />;
}
